import styled, { createGlobalStyle } from 'styled-components'
import { Link } from 'react-router-dom';

const GlobalStyle = createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Poppins',sans-serif;
        scroll-behavior:smooth;
        overflow-x: hidden;

    }
    body{
        /* background: linear-gradient(90deg, rgba(50,95,251,1) 16%, rgba(58,91,207,1) 43%, rgba(17,52,186,1) 68%); */
    }
    `
    export const Container = styled.div`
        padding:20px 80px 0 80px;
        position:relative;
        margin-right: auto;
        margin-left: auto;
            @media screen and (max-width: 768px) {
            padding-right: 10px;
            padding-left: 10px;
            }
        `;
    export const Button = styled.button`
        border-radius: 2px;
        background: ${({ primary }) => (primary ? '#4B59F7' : '#F9A826')};
        white-space: nowrap;
        padding: ${({ big }) => (big ? '12px 64px' : '8px 14px')};
        color: #fff;
        font-weight: bold;
        margin-bottom: ${({ margin }) => (margin ? '20px' : '0')};
        margin-left: ${({ left }) => (left ? '120px' : '0')};
        font-family: "Roboto",sans-serif;
        font-size: ${({ fontBig }) => (fontBig ? '18px' : '16px')};
        outline: none;
        border: none;
        cursor: pointer;
        transition: all 0.3s ease-in-out; 

        &:hover {
        transform: scaleX(1.1);

            /* transition: all 0.3s ease-in-out;
            background: #fff;
            background-color: ${({ primary }) => (primary ? '#0467FB' : '#B07C28')}; */
        }
    @media screen and (max-width: 768px) {
        width: 100%;
    }
    `;
 
    export const Wrapp = styled.div`
        position:relative;
        display:flex;
        margin-top: ${props => props.margin ? props.margin : '0'};
        justify-content:center;
        flex-direction:column;
        align-items:center;
    `
    export const Wrapps = styled.div`
        display:grid;
        margin-right:120px;
        margin-left:120px;
        grid-column-gap:40px;
        position:relative;
        grid-template-columns: auto auto auto auto ;
        justify-content:space-between;
        @media screen and (max-width: 1100px){
            grid-template-columns:250px 250px;
        }
        @media screen and (max-width: 600px){
            grid-template-columns:250px;
        }
        `
    export const WrappProjects = styled(Wrapps)`
        grid-template-columns: 330px 330px 330px;
        grid-column-gap:60px;
        @media screen and (max-width: 1130px){
            margin-right:120px;
            margin-left:120px;
            grid-template-columns:300px 300px;
            grid-row-gap:40px;
            grid-row-column:80px;
        }
        @media screen and (max-width: 768px){
            grid-template-columns:300px;
            grid-row-gap:20px;
        }
    `
    export const WrappsCerti = styled(Wrapps)`
        grid-template-columns:330px 330px 330px;
        @media screen and (max-width: 1100px){
            grid-template-columns:280px 280px;
        }
        @media screen and (max-width: 600px){
            grid-template-columns:250px;
        }
    `
    export const WrappCertificates = styled(Wrapp)`
        margin-top: ${({margin}) => (margin ? margin : '0')};
    `
  
    export const TitleSection = styled.h2`
        color: #000;
        margin-top: ${({margin}) => (margin ? '60px' : '0')};
        font-size:1.8em;
        text-align:center;
        font-weight:bold;
        margin-bottom:10px;
        @media screen and (max-width: 800px){
            font-size:1.2em;
        }
    `

    export const BorderBottom = styled.div`
        display:flex;
        justify-content:center;
        align-items:center;
        border:4px solid #F9A826;
        border-radius:8px;
        width: 80px;
        margin-bottom: 50px;
        position:relative;
    `
    export const Row = styled.div`
        display:flex;
        margin-top:30px;
        flex-wrap:wrap;
        position:relative;
        @media screen and (max-width: 1100px){
            margin-bottom:20px;
            align-items:center;
            justify-content:center;
            margin-top:0;
        }
    `
    export const More = styled(Link)`
        width:200px;
        height:50px;
        border-radius:4px;
        border:1px solid #F9A826;
        background:transparent;
        font-size:18px;
        font-weight:700;
        color:${({color}) => (color ? '#fff' : '#F9A826')};
        align-items:center;
        display:flex;
        justify-content:center;
        cursor:pointer;
        text-decoration:none;
        margin-top:80px;
        transition:.8s;
        &:hover{
            background:#F9A826;
            color:#fff;
        }
        @media screen and (max-width:800px){
            width:150px;
            font-size:16px;
            margin-top:20px;
            height:40px;
        }
    `
// Skill 

    export const SectionSKill = styled('div')`
        position:relative;
        display:flex;
        width:100%;
        background:#4a55da;
        justify-content:center;
        flex-direction:column;
        align-items:center;
        padding-bottom:50px;
    `
    export const WrappSkillDetail = styled(SectionSKill)`
        background:#fff;

    `
    export const BoxSkill = styled.div`
        width:250px;
        height:320px;
        border-radius:4px;
        border:1px solid #000;
        position:relative;
        padding:8px 14px;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        background:#fff;
        margin-top:40px;
        box-shadow: 0 2px 2px 1px rgba(0,0,0,0.4);
        &:hover{
            transition:.5s;
        }
    @media screen and (max-width:1100px){
        margin-top:40px;
    }
    `
    export const Img = styled.img`
        width:100%;
        height:150px;
        object-fit:contain;
    `
    export const Title = styled.h5`
        font-size:20px;
        font-weight:700;
        margin-top:10px;
        margin-bottom:10px;
        color:#000;
        @media (max-width:768px){
            padding-right: 8px;
            padding-left: 8px;
        }
    `
    export const Description = styled.p`
        font-size:14px;
        color:#595959;
    `
    export const ReadMore = styled(Link)`
        color:#000;
        font-size:14px;
        margin-top:10px;
        text-decoration:none;
        border:1px solid #000;
        padding:4px 12px;
        border-radius:4px;
        &:hover{
            transition:.5s;
            background:#000;
            color:#fff;
        }
    `

    //detail
    export const WrappDetail = styled.div`
        width:60%;
        display:flex;
        overflow: hidden;
        position:relative;
        flex-direction:column;
        margin-top:50px;
        padding:30px 30px 100px 30px;
        box-shadow:1px 2px 4px 1px rgba(0,0,0,0.2);
        @media (max-width:768px){
            margin-bottom:100px;
            padding:20px;
            width:100%;
        }
    `
    export const ImageDetail = styled.img`
        width:100%;
        height:auto;
        margin-bottom:60px;
        @media (max-width:768px){
            display:flex;
            justify-content: center;
            align-items: center;
            width:100%;
        }
    `
    export const TitleDetail = styled.h4`
        font-size:1.6em;
        color:#000;
        margin-top:20px;
        @media (max-width:768px){
            font-size:1em;
            padding-right: 8px;
            padding-left: 8px;
        }
    `
    export const TextBody = styled(Title)`
        font-size:1em;
        line-height:1.8em;
        letter-spacing: .8px;
        font-weight: 400;
        @media (max-width:768px){
            font-size:.8em;
            padding-right: 8px;
            padding-left: 8px;
        }
    `
    export const Wrapper = styled.div`
        width:100%;
        position:relative;
        display:flex;
        padding:20px;
        justify-content: space-between;
        @media(max-width:990px){
            flex-direction:column;
            padding: 0 8px;
        }

    `
    export const WrappRecomendation = styled.div`
        width:40%;
        position: relative;
        display:flex;
        margin-top:40px;
        flex-direction: column;
        padding-left:100px;
        @media(max-width:768px){
            width:100%;
            padding-left:0;
        }
    `
    export const Box = styled(Link)`
        width:260px;
        display:flex;
        text-decoration:none;
        margin-top:10px;
        position: relative;
        flex-direction:column;
        align-items: center;
        padding:10px 8px;
        transition:.5s;
        &:hover{
            cursor:pointer;
            /* border:1px solid #595959; */
            padding:14px 12px;
            box-shadow: 0 2px 2px 1px rgba(0,0,0,0.4);
            border-radius:2px;
        }
        @media(max-width:768px){
            margin-top:10px;
            align-items: flex-start;
        }
    `
    export const Span = styled.span`
        height:2px;
        border-bottom:2px solid rgba(0,0,0,0.2);
        width:100%;
    `
    export const DescriptionSide = styled.div`
        font-size: 14px;
        color:#595959;
        margin-bottom:10px;
    `
export default GlobalStyle;
